import * as YtCaptionActions from '../actions/youtube-captions'
import { ICaption, ICaptionsInfo } from '../models'

export interface State {
  info: ICaptionsInfo,
  languageCode: string,
  captions: ICaption[]
}

const initialState: State = {
  info: null,
  languageCode: null,
  captions: []
}

export function reducer(state: State = initialState, action: YtCaptionActions.All): State {
  switch (action.type) {
    case YtCaptionActions.INIT_CAPTION: {
      return {info: null, languageCode:null, captions:[]}
    }
    case YtCaptionActions.SELECT_VIDEO: {
      return { info: action.captionsInfo, languageCode:null, captions:[] }
    }
    case YtCaptionActions.SELECT_LANGUAGE: {
      return { ...state, languageCode:action.languageInfo.languageCode }
    }
    case YtCaptionActions.LOAD_CAPTION: {
      return { ...state, captions: action.captions }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/youtube-caption.ts